export default {
    model: {
        email: {
            label: "E-mail",
            placeholder: "Naam of e-mailadres van de afgevaardigde",
            notFound: "Gebruikers niet gevonden"
        },
        start_on: {
            label: "Startdatum",
            placeholder: "Datum waarop de delegatie van start gaat"
        },
        end_on: {
            label: "Einddatum",
            placeholder: "Optioneel"
        },
        accept: {
            tip: "Door uw goedkeuringsbevoegdheid te delegeren, verklaart u dat u de verantwoordelijkheid draagt voor alle door uw gemachtigde goedgekeurde orders.",
            label: "Ik ga akkoord"
        }
    },
    buttons: {
        submit: {
            cta: "Bevestigen",
            processing: "Besparing"
        },
        close: {
            cta: "Annuleren"
        }
    },
    saved: "Opgeslagen"
}